<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { SurveyCriteriaManagerDialogViewModel } from "@Evaluation/AlternativesSurveys/Components/SurveyCriteriaManagerDialog";

    @Component({
        props: {
            viewModel: { type: Object, required: true }
        }
    })
    export default class SurveyCriteriaManagerDialog extends Vue
    {
        get vm(): SurveyCriteriaManagerDialogViewModel { return this.$props.viewModel as SurveyCriteriaManagerDialogViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get initialized() { return this.vm.rm != null; }
        get criteria() { return this.vm.rm?.Criteria; }
        get surveyId() { return this.vm.surveyId; }
        get surveyName() { return this.vm.surveyName; }

        searchPhrase: string = null;

        get criteriaView()
        {
            if (this.searchPhrase)
            {
                const phrase = this.searchPhrase.toLowerCase();
                return this.criteria.filter(o => (o.Path + o.Name).toLowerCase().indexOf(phrase) >= 0);
            }

            return this.criteria;
        }


        emitUpdateCriteria()
        {
            const selectedCriteriaIds = this.criteria
                .filter(a => a.IsIncluded === true)
                .map(a => a.Id);

            this.$emit('update-survey-criteria', this.surveyId, selectedCriteriaIds);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content" style="height: calc(100vh - 50px);">
                    <div class="modal-header">
                        <h5 class="modal-title">Select criteria: {{surveyName}}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <h2 v-if="initialized === false"><i class="fa fa-spinner fa-spin"></i> Loading...</h2>
                        <div v-if="initialized">
                            <div class="alert alert-info alert-dismissible" role="alert">
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                You can limit which criteria are included in your panel. To do that, simply check the criteria you want to include from the list below.
                                <strong>WARNING: New criteria won't be included in panels automatically.</strong>
                            </div>

                            <div class="input-group input-group-lg">
                                <input type="search" placeholder="Search for a criterion..." class="form-control" v-model="searchPhrase">
                                <span class="input-group-append">
                                    <span class="input-group-text"><i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i></span>
                                </span>
                            </div>

                            <br />
                            <div class="list-group">
                                <button type="button" v-for="c in criteriaView" :key="c.Id" @click="c.IsIncluded = !c.IsIncluded" class="list-group-item list-group-item-action">
                                    <span v-if="c.IsIncluded === true" class="fa-regular fa-square-check"></span>
                                    <span v-if="c.IsIncluded === false" class="fa-regular fa-square"></span>
                                    <span>{{c.Path}}</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="emitUpdateCriteria" type="button" class="btn btn-primary">Save &amp; Close</button>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>